module.exports = __webpack_public_path__ + "img/icons B_18.d4829ed6.svg";